<template>
    <div class="home" v-if="doneLoading">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>
                        CNA Renewal Application Rejection
                    </h1>
                </b-col>
            </b-row>
            <div class="card">
                <div class="card-header">Applicant's Personal Information</div>
                <div class="card-body">
                    <b-row>
                        <b-col>
                            These fields are not editable from applicant's view.
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Last Name" :value="profile.lastName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="First Name" :value="profile.firstName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Middle Name" :value="profile.middleName"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Date Of Birth" :value="formatDate(profile.dateOfBirth)"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Social Security Number" :value="profile.ssn"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <OtherNames :items="profile.nameChanges"/>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Applicant's Address and Contact Information</div>
                <div class="card-body">
                    <b-row v-if="showPersonalInfoCorrections">
                        <b-col>
                            <p>Select checkbox next to items that have issues</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.streetAddress" :v="$v.personalInfoCorrections.address.streetAddress"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Street Address" :value="profile.contact.address.streetAddress" v-bind:class="personalInfoCorrections.address.streetAddress?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.city" :v="$v.personalInfoCorrections.address.city"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="City" :value="profile.contact.address.city" v-bind:class="personalInfoCorrections.address.city?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.state" :v="$v.personalInfoCorrections.address.state"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="State" :value="profile.contact.address.state" v-bind:class="personalInfoCorrections.address.state?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.postalCode" :v="$v.personalInfoCorrections.address.postalCode"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Zip" :value="profile.contact.address.postalCode" v-bind:class="personalInfoCorrections.address.postalCode?'text-danger':''"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.phone" :v="$v.personalInfoCorrections.phone"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Cell Phone Number" :value="profile.contact.phone" v-bind:class="personalInfoCorrections.phone?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.email" :v="$v.personalInfoCorrections.email"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Email Address" :value="profile.contact.email" v-bind:class="personalInfoCorrections.email?'text-danger':''"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <BaseParagraphInput v-if="showPersonalInfoCorrections" v-model="personalInfoCorrections.reasons" :v="$v.personalInfoCorrections.reasons" label="Rejection reasons for personal details:" tip="Will be shared with applicant"/>
                            <BaseTextOutput v-else-if="personalInfoCorrections.reasons!==''" label="Rejection reasons for personal details:" :value="personalInfoCorrections.reasons"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button @click="showPersonalInfoCorrections=!showPersonalInfoCorrections">{{showPersonalInfoCorrections?'Close':'Open'}} Corrections</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card" v-for="(employer, index) in application.employers" :key="index">
                <div class="card-header">Employer {{index+1}} of {{application.employers.length}}</div>
                <div class="card-body">
                  <b-row v-if="employer.staffReport">
                    <b-col>
                      <p>This employer is a Minnesota Nursing Home or Boarding Care Home. Applicant is only able to change name, department, staffing agency, <span v-if="employer.staffReport.verified.code==='VERIFIED'">and </span>start date<span v-if="employer.staffReport.verified.code!=='VERIFIED'">, and end date</span>, or replace this entry entirely.</p>
                    </b-col>
                  </b-row>
                    <b-row v-if="employerInfoCorrections[index].show">
                        <b-col>
                            <p>Select checkbox next to items that have issues</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].name" :v="$v.employerInfoCorrections.$each[index].name"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Employer Name" :value="employer.name" v-bind:class="employerInfoCorrections[index].name?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].department" :v="$v.employerInfoCorrections.$each[index].department"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Department" :value="employer.department" v-bind:class="employerInfoCorrections[index].department?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].staffingAgency" :v="$v.employerInfoCorrections.$each[index].staffingAgency"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Staffing Agency" :value="employer.staffingAgency?'Yes':'No'" v-bind:class="employerInfoCorrections[index].staffingAgency?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show  && !employer.staffReport">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].facilityType" :v="$v.employerInfoCorrections.$each[index].facilityType"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Facility Type" :value="employer.facilityType.description" v-bind:class="employerInfoCorrections[index].facilityType?'text-danger':''"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show  && !employer.staffReport">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].address.streetAddress" :v="$v.employerInfoCorrections.$each[index].address.streetAddress"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Street Address" :value="employer.address.streetAddress" v-bind:class="employerInfoCorrections[index].address.streetAddress?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show  && !employer.staffReport">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].address.city" :v="$v.employerInfoCorrections.$each[index].address.city"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="City" :value="employer.address.city" v-bind:class="employerInfoCorrections[index].address.city?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show  && !employer.staffReport">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].address.state" :v="$v.employerInfoCorrections.$each[index].address.state"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="State" :value="employer.address.state" v-bind:class="employerInfoCorrections[index].address.state?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show  && !employer.staffReport">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].address.postalCode" :v="$v.employerInfoCorrections.$each[index].address.postalCode"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Zip Code" :value="employer.address.postalCode" v-bind:class="employerInfoCorrections[index].address.postalCode?'text-danger':''"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].startDate" :v="$v.employerInfoCorrections.$each[index].startDate"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Start Date" :value="employer.startDate" v-bind:class="employerInfoCorrections[index].startDate?'text-danger':''"/>
                        </b-col>
                        <b-col cols="0" v-if="employerInfoCorrections[index].show && (!employer.staffReport || employer.staffReport.verified.code!=='VERIFIED')">
                            <BaseCheckboxInput v-model="employerInfoCorrections[index].endDate" :v="$v.employerInfoCorrections.$each[index].endDate"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="End Date" :value="employer.endDate" v-bind:class="employerInfoCorrections[index].endDate?'text-danger':''"/>
                        </b-col>
                    </b-row>
                    <b-row v-for="(attachment, attachmentIndex) in employer.attachments" v-bind:key="attachmentIndex" v-bind:class="employerInfoCorrections[index].attachments[attachmentIndex].mark?'text-danger':''">
                      <b-col cols="0" v-if="employerInfoCorrections[index].show">
                        <BaseCheckboxInput v-model="employerInfoCorrections[index].attachments[attachmentIndex].mark" :v="$v.employerInfoCorrections.$each[index].attachments.$each[attachmentIndex]"/>
                      </b-col>
                      <b-col cols="2">
                        <BaseTextOutput label="File name" :value="attachment.filename"/>
                      </b-col>
                      <b-col cols="2">
                        <BaseTextOutput label="Type" :value="attachment.type.description"/>
                      </b-col>
                      <b-col cols="2" v-if="attachment.otherType">
                        <BaseTextOutput :label="attachment.type.code==='W2'?'Year(s)':(attachment.type.code==='PS'?'Paystub type':'Other attachment type')" :value="attachment.otherType"/>
                      </b-col>
                      <b-col cols="2">
                        <BaseTextOutput label="OCR Grade" :value="attachment.grade.description"/>
                      </b-col>
                      <b-col cols="2">
                        <b-button variant="secondary" @click="downloadAttachment(attachment)">Download</b-button>
                      </b-col>
                      <b-row v-if="attachment.concerns">
                        <b-col>
                          <BaseTextOutput label="OCR Concerns" :value="attachment.concerns"/>
                        </b-col>
                      </b-row>
                    </b-row>
                  <b-row>
                    <b-col>
                      <BaseParagraphInput v-if="employerInfoCorrections[index].show" label="Rejection reasons for employer:" tip="Will be shared with applicant" v-model="employerInfoCorrections[index].reasons" :v="$v.employerInfoCorrections.$each[index].reasons"/>
                      <BaseTextOutput v-else-if="employerInfoCorrections[index].reasons" label="Rejection reasons for employer:" :value="employerInfoCorrections[index].reasons"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button @click="employerInfoCorrections[index].show=!employerInfoCorrections[index].show">{{employerInfoCorrections[index].show?'Close':'Open'}} Corrections</b-button>
                    </b-col>
                  </b-row>
                </div>
            </div>

                <b-row v-if="showSubmitError">
                    <b-col>
                        <div class="text-danger">You need to mark something for corrections</div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button variant="primary" @click="submit" :disabled="disableButton">Submit corrections</b-button>
                    </b-col>
                </b-row>

        </b-container>
    </div>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import OtherNames from "@/components/templates/OtherNames";
    import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput";
    import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput";

    export default {
        name: "RenewalRejection",
        components:{
            BaseTextOutput,
            OtherNames,
            BaseCheckboxInput,
            BaseParagraphInput,
        },
        data:()=>({
            disableButton: false,
            doneLoading: false,
            application: null,
            profile: null,
            certificate: null,
            showPersonalInfoCorrections: false,
            personalInfoCorrections:{
                address:{
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null
                },
                phone: null,
                email: null,
                reasons: ''
            },
            employerInfoCorrections: [],
            showSubmitError: false,
            applicationId: null,

        }),
        created() {
            this.loadApplication();
        },
        methods: {
            loadApplication() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/renewal/${this.$route.params.id}`)
                    .then(response => {
                        this.application = response.data.application;
                        this.applicationId = this.application.id;
                        this.profile = response.data.profile;
                        this.certificate = response.data.certificate;
                        for(let i=0;i<response.data.application.employers.length;i++){
                            if(response.data.application.employers[i].facilityType==null){
                                response.data.application.employers[i].facilityType = {code: null, description: null};
                            }
                            let employerInfoCorrection = {
                                id: response.data.application.employers[i].id,
                                show: null,
                                name: null,
                                department: null,
                                address: {
                                    streetAddress: null,
                                    city: null,
                                    state: null,
                                    postalCode: null
                                },
                                attachments:[],
                                reasons: '',
                                startDate: null,
                                endDate: null,
                                staffingAgency: null,
                                facilityType: null
                            };
                            for(let j=0;j<response.data.application.employers[i].attachments.length;j++){
                              employerInfoCorrection.attachments.push({
                                id: response.data.application.employers[i].attachments[j].attachmentId,
                                mark: null,
                              })
                            }
                            this.employerInfoCorrections.push(employerInfoCorrection);
                        }
                        this.$nextTick(()=>{
                            this.doneLoading=true;
                        })
                    }).finally(() => {
                    //this.findMostRecentExpirationAndApprovalDate();
                })
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            hasAttachment(employer, type){
                return employer.attachments.find(x=>x.type.code === type)!=null;
            },
            getAttachmentName(employer, type){
                let attachment = employer.attachments.find(x=>x.type.code === type);
                if(attachment){
                    return attachment.filename;
                }
                return "N/A";
            },
            getAttachmentOCRConcerns(employer, type){
                let attachment = employer.attachments.find(x=>x.type.code === type);
                if(attachment){
                    return attachment.concerns;
                }
                return "N/A";
            },
            submit(){
              this.disableButton = true;
                if(this.checkForCorrections()){
                    this.showSubmitError = false;
                    let payload = {
                        personalInfoCorrections: this.personalInfoCorrections,
                        employerInfoCorrections: this.employerInfoCorrections
                    };
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/approval/reject/`+this.applicationId, JSON.stringify(payload))
                        .then(response=>{
                            this.showRootToast('Application returned', 'The application has been successfully returned to applicant', 'success');
                            this.loadApplication();
                        }).catch(error=> {
                        if (error.response.status === 406) {
                            this.showRootToast('Error returning application', 'This application is not in a status from which it can be returned to the applicant', 'danger');
                        } else if (error.response.status === 404) {
                            this.showRootToast('Not found', 'Application not found', 'danger');
                        } else {
                            this.showRootToast('Error returning application', 'An error occurred while returning this application', 'danger');
                        }
                      this.disableButton=false;
                    })
                }
                else{
                    this.showSubmitError = true;
                    this.disableButton=false;
                }
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
            downloadAttachment(attachment){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/` + attachment.attachmentId)
                    .then(response=>{
                        if(response.data){
                            window.open(response.data,"_blank");
                        }
                        else{this.$emit('attachment-get-failure')}
                    })
            },
            checkForCorrections(){
                let iter = [];
                let flattenedObject = this.flattenObject(this.personalInfoCorrections);
                iter = iter.concat(Object.values(flattenedObject));
                for(let i=0;i<this.employerInfoCorrections.length;i++){
                    flattenedObject = this.flattenObject(this.employerInfoCorrections[i]);
                    delete flattenedObject.show;
                    delete flattenedObject.id;
                    iter = iter.concat(Object.values(flattenedObject));
                }
                for(let i=0;i<iter.length;i++){
                    if(iter[i]){
                        return true;
                    }
                }
                return false;
            },
            flattenObject(obj){
                const flattened = {}

                Object.keys(obj).forEach((key) => {
                    const value = obj[key]

                    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        Object.assign(flattened, this.flattenObject(value))
                    } else {
                        flattened[key] = value
                    }
                })

                return flattened
            },
        },
        validations:{
            personalInfoCorrections:{
                required: false,
                address:{
                    required: false,
                    streetAddress: {
                        required: false
                    },
                    city:  {
                        required: false
                    },
                    state:  {
                        required: false
                    },
                    postalCode:  {
                        required: false
                    },
                },
                phone:  {
                    required: false
                },
                email:  {
                    required: false
                },
                reasons: {
                    required: false
                }
            },
            showPersonalInfoCorrections: {required: false},
            employerInfoCorrections: {
                required: false,
                $each:{
                    required: false,
                    id:{required: false},
                    show:{required: false},
                    name:{required:false},
                    department: {required: false},
                    address:{
                        streetAddress: {required: false},
                        city: {required: false},
                        state: {required: false},
                        postalCode: {required: false}
                    },
                    attachments:{
                        $each:{
                          required: false,
                          id:{required: false},
                          mark:{required: false}
                        }
                    },
                    reasons:{required: false},
                    startDate:{required: false},
                    endDate:{required: false},
                    staffingAgency: {required: false},
                    facilityType: {required: false}
                }
            }
        },

    }
</script>

<style scoped>

</style>